import { render, staticRenderFns } from "./ErrorMessage.vue?vue&type=template&id=42c3967d&"
import script from "./ErrorMessage.vue?vue&type=script&lang=js&"
export * from "./ErrorMessage.vue?vue&type=script&lang=js&"
import style0 from "./ErrorMessage.vue?vue&type=style&index=0&id=42c3967d&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/digital-seaside/sst-admin-panel/webapp/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('42c3967d')) {
      api.createRecord('42c3967d', component.options)
    } else {
      api.reload('42c3967d', component.options)
    }
    module.hot.accept("./ErrorMessage.vue?vue&type=template&id=42c3967d&", function () {
      api.rerender('42c3967d', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/error-messages/ErrorMessage.vue"
export default component.exports